/**
 * @exports separateNumber
 * @since 2.9.0
 */
import { CONVERTER_DEFAULTS } from '../CurrencyConverter/constants';

/**
 * Convert a number to a string representation with a given thousands separator.
 * @param  {Number|String} num The number to convert.
 * @param  {String} [options.thousandsSeparator=','] The thousands separator to use for separation.
 * @return {String}
 *
 * @example
 * separateNumber('1000') = '1,000';
 * separateNumber('3000', {thousandsSeparator: '.'}) = '3.000';
 */
export const separateNumber = (num, { thousandsSeparator = CONVERTER_DEFAULTS.thousandsSeparator } = {}) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
